/**
 * @generated SignedSource<<c4d48d34d7e3418b9cbce4401c6f8717>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type RightFrameMultipleChoiceElementPart_SubmittedAnswersQuery$variables = {
  submissionId: string;
};
export type RightFrameMultipleChoiceElementPart_SubmittedAnswersQuery$data = {
  readonly LearnV2: {
    readonly GetSubmittedAnswers: ReadonlyArray<{
      readonly answerIndices: ReadonlyArray<number>;
      readonly answers: ReadonlyArray<string>;
      readonly elementId: string;
      readonly question: string;
    }>;
  };
};
export type RightFrameMultipleChoiceElementPart_SubmittedAnswersQuery = {
  response: RightFrameMultipleChoiceElementPart_SubmittedAnswersQuery$data;
  variables: RightFrameMultipleChoiceElementPart_SubmittedAnswersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "submissionId"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LearnV2Queries",
    "kind": "LinkedField",
    "name": "LearnV2",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "submissionId",
            "variableName": "submissionId"
          }
        ],
        "concreteType": "MultipleChoiceDecision",
        "kind": "LinkedField",
        "name": "GetSubmittedAnswers",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "elementId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "question",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "answers",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "answerIndices",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RightFrameMultipleChoiceElementPart_SubmittedAnswersQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RightFrameMultipleChoiceElementPart_SubmittedAnswersQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "322a9fa89a3deb651c28ca17cb28b213",
    "id": null,
    "metadata": {},
    "name": "RightFrameMultipleChoiceElementPart_SubmittedAnswersQuery",
    "operationKind": "query",
    "text": "query RightFrameMultipleChoiceElementPart_SubmittedAnswersQuery(\n  $submissionId: ID!\n) {\n  LearnV2 {\n    GetSubmittedAnswers(submissionId: $submissionId) {\n      elementId\n      question\n      answers\n      answerIndices\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bfa306f63dbe08bd094bf8bcb951672b";

export default node;
